// Search.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import { replace } from '../action/navigationAction.js';
import { fetchMessageSearch } from '../action/fetchMessageSearch.js';
import { fetchUserSearch } from '../action/fetchUserSearch.js';
import getOperationData from '../selector/getOperationData.js';
import Search from '../page/Search.jsx';
import withSearchQuery from '../component/WithSearchQuery.jsx';
import withRouter from '../component/WithRouter.jsx';

const mapStateToProps = (state, { query, match }) => {
  const type = match.params.type;
  const category = match.params?.category || '';

  const swaggerOnlineFeed = getOperationData(
    state,
    ['swaggerOnlineFeed'],
    'search'
  );
  const swaggerNewFeed = getOperationData(state, ['swaggerNewFeed'], 'search');
  return {
    type,
    category,
    query,
    swaggerOnlineFeed,
    swaggerNewFeed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: (...args) => dispatch(replace(...args)),
    fetchMessageSearch: data => dispatch(fetchMessageSearch(data)),
    fetchUserSearch: data =>
      dispatch(
        fetchUserSearch({
          ...data,
          selectPath: ['search', 'user', data.query],
        })
      ),
    goBack: () => dispatch(goBack()),
  };
};

export default withSearchQuery(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Search))
);
